import { z } from 'zod'

import { richTextDocSchema } from '../cms.rich-text'
import { blockOf, subListItemOf } from './common'
import { BlockType } from './types'

export const faqItemSchema = z.object({
    ...subListItemOf(),
    question: z.string(),
    answer: richTextDocSchema,
})

export type FaqItem = z.infer<typeof faqItemSchema>

export const faqBlockSchema = z.object({
    ...blockOf(BlockType.FAQ),
    title: z.string(),
    items: z.array(faqItemSchema),
})

export type FaqBlockData = z.infer<typeof faqBlockSchema>
